module.exports = __webpack_public_path__ + "static/media/engageorangeLogo.75da3410.png";